import { render, staticRenderFns } from "./BtnsSpecimensPage.vue?vue&type=template&id=7d0bf302&scoped=true"
import script from "./BtnsSpecimensPage.vue?vue&type=script&lang=js"
export * from "./BtnsSpecimensPage.vue?vue&type=script&lang=js"
import style0 from "./BtnsSpecimensPage.vue?vue&type=style&index=0&id=7d0bf302&prod&lang=scss&scoped=true"
import style1 from "./BtnsSpecimensPage.vue?vue&type=style&index=1&id=7d0bf302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0bf302",
  null
  
)

export default component.exports